<template>
  <div>
    <div class="addFormBox">
      <!--基础数据-->
      <div class="title">{{ $t('basicData.UnderlyingData') }}</div>
      <el-form
        ref="queryForm"
        class="queryFormClass"
        size="small"
        :model="formData"
        :rules="rules"
        label-position="top"
      >
        <el-row :gutter="10">
          <!--报价方案名称-->
          <el-col :span="6">
            <el-form-item :label="$t('basicData.TheNameOfTheQuoteProposal')" prop="name">
              <el-input
                v-model.trim="formData.name"
                :placeholder="$t('orderDetails.pleaseInput')"
                clearable
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <!--有效期开始-->
          <el-col :span="6">
            <el-form-item :label="$t('basicData.TheValidityPeriodBegins')" prop="startOfValidityPeriod">
              <el-date-picker
                v-model="formData.startOfValidityPeriod"
                type="datetime"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%;"
                :disabled="isDisableData"
                :picker-options="pickerOptions"
                :placeholder="$t('basicData.SelectADatetime')"
              />
            </el-form-item>
          </el-col>
          <!--业务类型-->
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
              <el-select
                v-model="formData.businessType"
                style="width: 100%;"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                @change="changeBusinessType"
              >
                <el-option
                  v-for="item in PAYABLE_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 如果“业务类型”选中“第三方揽收，则显示揽收方式并且必填 -->
          <el-col v-if="formData.businessType === 2" :span="6">
            <el-form-item
              :rules="{ required: formData.businessType === 2, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              :label="$t('collectionCenter.lanshouTypee')"
              prop="collectType"
            >
              <el-select
                v-model="formData.collectType"
                filterable
                clearable
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                @change="collectTypeChange()"
              >
                <el-option
                  v-for="item in COLLECT_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 如果“业务类型”选中“AJD/DSP“，则显示货物类型 -->
          <el-col v-if="[3,4].includes(formData.businessType)" :span="6">
            <!--货物类型-->
            <el-form-item
              :rules="{ required: [3,4].includes(formData.businessType), message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              :label="$t('placeOrder.cargoType')"
              prop="cargoType"
            >
              <el-select
                v-model="formData.cargoType "
                filterable
                clearable
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in CARGO_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--业务类型不为运输才显示分区方案-->
          <el-col v-if="[1,2,3,4,6].includes(formData.businessType)" :span="6">
            <el-form-item
              :label="$t('basicData.PartitionSchemeName')"
              prop="partitionId"
            >
              <el-select
                v-model="formData.partitionId"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                filterable
                clearable
                @change="getOtherFeeDetail()"
              >
                <el-option
                  v-for="item in partitionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--业务类型为运输才显示运输类型-->
          <el-col v-if="formData.businessType === 5" :span="6">
            <el-form-item
              :label="$t('basicData.transportType')"
              prop="transportType"
            >
              <el-select
                v-model="formData.transportType"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                clearable
              >
                <el-option
                  v-for="item in TRANSPORTATION_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--运输主体-->
          <el-col v-if="formData.businessType === 5" :span="6">
            <el-form-item :label="$t('basicData.PayablePrincipal')" prop="payableEntityId">
              <el-select
                v-model="formData.payableEntityId"
                filterable
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                @change="providerInfoChange"
              >
                <el-option
                  v-for="item in transportationProviderList"
                  :key="item.id"
                  :label="`${item.providerName}（${item.code}）`"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 应付主体-->
          <el-col v-else :span="6">
            <el-form-item :label="$t('basicData.PayablePrincipal')" prop="payableEntityId">
              <el-select
                v-model="formData.payableEntityId"
                filterable
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                style="width: 100%;"
                remote
                :remote-method="getProviderList"
                @change="providerInfoChange"
              >
                <el-option
                  v-for="item in providerData"
                  :key="item.id"
                  :label="`${item.providerBody}（${item.providerName}）（${item.code}）`"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--网点 运输/邮局派送不显示-->
          <el-col v-if="![5,6].includes(formData.businessType)" :span="6">
            <el-form-item :label="$t('basicData.Outlets')" prop="siteIds">
              <el-select
                v-model="formData.siteIds"
                filterable
                clearable
                :multiple="!editData.id"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                @change="siteIdChange(formData.siteIds)"
              >
                <!--请先选择主体-->
                <el-option v-if="!formData.payableEntityId" value="">
                  <span style="color:#f00;font-weight: bold">{{ $t('basicData.PleaseSelectThePayableEntity') }}</span>
                </el-option>
                <el-option
                  v-for="item in outletsList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--AJD账单显示 结算节点-->
          <el-col v-if="formData.businessType === 3" :span="6">
            <el-form-item
              :rules="{ required: formData.businessType === 3, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              :label="$t('basicData.SettlementNode')"
              prop="settlementNode"
            >
              <el-select
                v-model="formData.settlementNode"
                filterable
                clearable
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                disabled
              >
                <!--派送任务-->
                <el-option :label="$t('basicData.DeliveryTask')" :value="1" />
                <!--签收-->
                <el-option :label="$t('basicData.signFor')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 邮局派送显示-->
          <template v-if="formData.businessType === 6">
            <el-col :span="6">
              <!--服务商渠道-->
              <el-form-item
                :label="$t('GlobalSetObj.ServiceProviderChannels')"
                prop="providerChannelId"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="formData.providerChannelId"
                  filterable
                  clearable
                  :placeholder="$t('GlobalSetObj.pleaseSelectChannel')"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in ProviderChannelList"
                    :key="item.id"
                    :label="item.providerChannelName"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--使用材积计费-->
              <el-form-item :label="$t('customerManagements.VolumeBilling')">
                <div class="volume">
                  <!-- 是否使用材积计费，（0：否；1：是） -->
                  <el-form-item label="" label-width="5px">
                    <el-checkbox v-model="formData.useVolumeBilling" :false-label="0" :true-label="1" />
                  </el-form-item>

                  <!-- 计算方式(0:*,1:/) -->
                  <el-form-item label="" label-width="5px" prop="calculationMethod">
                    <el-select
                      v-model="formData.calculationMethod"
                      :disabled="!formData.useVolumeBilling"
                      :placeholder="$t('operationCenter.PleaseSelect')"
                      style="width: 100px; margin-left: 5px;"
                    >
                      <el-option :value="0" label="*" />
                      <el-option :value="1" label="/" />
                    </el-select>
                  </el-form-item>

                  <!-- 计算基数 -->
                  <el-form-item label="" label-width="5px" prop="calculateBase">
                    <el-input-number
                      v-model="formData.calculateBase"
                      :controls="false"
                      :disabled="!formData.useVolumeBilling"
                      :max="999999999"
                      :min="0"
                      :placeholder="$t('customerManagements.pleaseInput')"
                      :precision="2"
                      style="margin-left: 5px;"
                    />
                  </el-form-item>
                </div>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </el-form>

      <!--价格详情-->
      <div class="title"> {{ $t('basicData.PriceDetails') }}</div>
      <div>
        <!--分区-->
        <div v-if="formData.partitionId" class="flex mb10">
          <label class="el-form-item__label" style="line-height: 32px;">{{ $t('basicData.PartitionName') }}：</label>
          <QueryPartVCmp
            :val="formData.partitionAffiliateId"
            :list="subregionList"
            :clearable="false"
            style="width: 400px;"
            @change="val => formData.partitionAffiliateId = val"
          />
        </div>

        <!--运输干支线才显示-->
        <div v-if="formData.businessType === 5" class="flex mb10">
          <!-- 车线 -->
          <label class="el-form-item__label" style="line-height: 32px;">{{ $t('basicData.routeName') }}：</label>
          <el-select
            v-model="formData.partitionAffiliateId"
            filterable
            :placeholder="$t('operationCenter.PleaseSelect')"
            :clearable="false"
            style="width: 400px;"
            size="small"
          >
            <el-option
              v-for="item in stitchingLine"
              :key="item.id"
              :label="item.name + '（' + item.code + '）'"
              :value="item.id"
            />
          </el-select>
        </div>

        <!-- AJD【大件】、DSP派送及安俊小屋 操作按钮 -->
        <template v-if="[1].includes(formData.businessType) || isDsp">
          <div class="mb10 feet-r">
            <!-- 添加一行 -->
            <el-button
              v-permit:remove="'btn:payable:quoteManagement:addEdit'"
              size="small"
              type="primary"
              @click="handleAdd()"
            >{{ $t('basicData.AddARow') }}</el-button>
            <!--  导入/下载  -->
            <el-popover placement="bottom-start" trigger="hover">
              <ImportDownload
                :key="exportKey"
                :expense-type-list="expenseTypeList"
                :operation-mode="formData.operationMode"
                :table-data-obj="(subregionList && subregionList.length > 0) ? tableDataObj : tableDataArr"
                :table-data="{ formData, subregionList }"
                @importPartition="importPartition"
              />
              <template #reference>
                <el-button size="small" plain>{{ $t('basicData.ImportDownload') }}</el-button>
              </template>
            </el-popover>
            <!-- 清空报价 -->
            <el-popover placement="bottom-start" trigger="hover">
              <!-- 清空当前分区 -->
              <div class="feet">
                <el-button
                  size="small"
                  type="primary"
                  @click="clearOffers(1)"
                >{{ $t('basicData.EmptyCurrentPartition') }}
                </el-button>

                <!-- 清空所有分区 -->
                <el-button
                  class="feet-btn"
                  size="small"
                  type="primary"
                  @click="clearOffers(2)"
                >{{ $t('basicData.EmptyAllPartitions') }}
                </el-button>
              </div>
              <!--清空报价-->
              <template #reference>
                <el-button
                  v-permit:remove="'btn:payable:quoteManagement:addEdit'"
                  size="small" plain
                >{{ $t('basicData.ClearTheOffer') }}</el-button>
              </template>
            </el-popover>
          </div>
        </template>
      </div>

      <!-- 第三方揽收（业务类型） + 上门交件（揽收方式） 显示此组件 -->
      <CollectionForwardingCentreHomeDeliveryCmp
        v-show="isCollectionForwardingCentreHomeDeliveryCmp"
        ref="collectionForwardingCentreHomeDeliveryRef"
        :subregion-list="subregionList"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
      />

      <!-- 第三方揽收（业务类型） + 上门揽收（揽收方式）展示此组件 -->
      <CollectionAndDoorToDoorCollectionAndThirdPartyCmp
        v-show="isCollectionAndDoorToDoorCollectionAndThirdParty"
        ref="collectionAndDoorToDoorCollectionAndThirdPartyRef"
        :subregion-list="subregionList"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
      />

      <!-- 业务类型AJD派送 显示此组件 -->
      <AJDAddCmp
        v-show="isBusinessType3AndOperationMode1"
        ref="ajdAddRef"
        :subregion-list="subregionList"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
      />

      <!-- 业务类型DSP派送/AJD【大件】 -->
      <template v-if="isDsp">
        <div style="margin-top: 10px;" class="priceTableForm">
          <el-form
            ref="tableForm1"
            :model="formData"
            label-width="0"
            label-position="top"
            class="error-form"
            size="mini"
          >
            <el-table :data="formData.collectFeesList" border>
              <!-- 费用类型 -->
              <el-table-column :label="$t('basicData.ExpenseType')" min-width="180">
                <template #header>
                  <div>
                    <span style="color: red;">*</span>
                    <span>{{ $t('basicData.ExpenseType') }}</span>
                  </div>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.feeTypeCode'"
                    :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                  >
                    <el-select
                      v-model="scope.row.feeTypeCode"
                      :placeholder="$t('basicData.PleaseSelect')"
                      style="width: 100%;"
                      @change="chargeTypeChange(scope)"
                    >
                      <el-option
                        v-for="item in expenseTypeList"
                        :key="item.id"
                        :label="item.displayName + '(' + item.code + ')'"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <!--重量开始KG（不包含）-->
              <el-table-column :label="$t('basicData.WeightStartKG')" min-width="180">
                <template #header>
                  <div>
                    <span style="color: red;">*</span>
                    <span>{{ $t('basicData.WeightStartKG') }}</span>
                  </div>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.startWeight'"
                    :rules="{
                      required: true,
                      negative: '',
                      suffix: 3,
                      negative1: 1,
                      package: scope.row.endWeight,
                      validator: priceType,
                      trigger: ['blur', 'change']
                    }"
                  >
                    <el-input v-model="scope.row.startWeight" />
                  </el-form-item>
                </template>
              </el-table-column>
              <!--重量结束KG（包含）-->
              <el-table-column :label="$t('basicData.WeightEndKG')" min-width="180">
                <template #header>
                  <div>
                    <span style="color: red;">*</span>
                    <span>{{ $t('basicData.WeightEndKG') }}</span>
                  </div>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.endWeight'"
                    :rules="{
                      required: true,
                      negative: '',
                      suffix: 3,
                      negative1: 2,
                      package: scope.row.startWeight,
                      validator: priceType,
                      trigger: ['blur', 'change']
                    }"
                  >
                    <el-input v-model="scope.row.endWeight" />
                  </el-form-item>
                </template>
              </el-table-column>
              <!--0-30KM价格-->
              <el-table-column :label="'0-31KM' + $t('basicData.Price')" min-width="180">
                <template #header>
                  <div>
                    <span style="color: red;">*</span>
                    <span>{{ '0-31KM' + $t('basicData.Price') }}</span>
                  </div>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.innerDistancePrice'"
                    :rules="{ required: true, suffix: 5, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                  >
                    <el-input v-model="scope.row.innerDistancePrice" />
                  </el-form-item>
                </template>
              </el-table-column>
              <!--'31-101KM价格'-->
              <el-table-column :label="'31-101KM' + $t('basicData.Price')" min-width="180">
                <template #header>
                  <div>
                    <!-- <span style="color: red;">*</span>-->
                    <span>{{ '31-101KM' + $t('basicData.Price') }}</span>
                  </div>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.outerDistancePrice'"
                    :rules="{ required: false, suffix: 5, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                  >
                    <el-input v-model="scope.row.outerDistancePrice" />
                  </el-form-item>
                </template>
              </el-table-column>
              <!--'>=101KM价格'-->
              <el-table-column :label="'>=101KM' + $t('basicData.Price')" min-width="180">
                <template #header>
                  <div>
                    <!-- <span style="color: red;">*</span>-->
                    <span>{{ '>=101KM' + $t('basicData.Price') }}</span>
                  </div>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.greaterThanDistancePrice'"
                    :rules="{ required: false, suffix: 5, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                  >
                    <el-input v-model="scope.row.greaterThanDistancePrice" />
                  </el-form-item>
                </template>
              </el-table-column>
              <!--0-31KM超出重量加价（每KG）-->
              <el-table-column :label="'0-31KM' + $t('basicData.ExcessWeightFareIncrease')" min-width="200">
                <template #header>
                  <span>{{ '0-31KM' + $t('basicData.ExcessWeightFareIncrease') }}</span>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.overWeightExtraPrice'"
                    :rules="{ required: false, suffix: 5, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                  >
                    <el-input v-model="scope.row.overWeightExtraPrice" />
                  </el-form-item>
                </template>
              </el-table-column>
              <!--'31-101KM超出重量加价（每KG）'-->
              <el-table-column :label="'31-101KM' + $t('basicData.ExcessWeightFareIncrease')" min-width="240">
                <template #header>
                  <span>{{ '31-101KM' + $t('basicData.ExcessWeightFareIncrease') }}</span>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.overKilometerExtraPrice'"
                    :rules="{ required: false, suffix: 5, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                  >
                    <el-input v-model="scope.row.overKilometerExtraPrice" />
                  </el-form-item>
                </template>
              </el-table-column>
              <!--'>=101KM超出重量加价（每KG）'-->
              <el-table-column :label="'>=101KM' + $t('basicData.ExcessWeightFareIncrease')" min-width="240">
                <template #header>
                  <span>{{ '>=101KM' + $t('basicData.ExcessWeightFareIncrease') }}</span>
                </template>
                <template v-slot="scope">
                  <el-form-item
                    :prop="'collectFeesList.' + scope.$index + '.greaterThanKilometerExtraPrice'"
                    :rules="{ required: false, suffix: 5, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                  >
                    <el-input v-model="scope.row.greaterThanKilometerExtraPrice" />
                  </el-form-item>
                </template>
              </el-table-column>
              <!--操作-->
              <el-table-column :label="$t('basicData.operate')" width="120" fixed="right">
                <template v-slot="scope">
                  <!--确定删除吗？-->
                  <el-popconfirm
                    :title="$t('basicData.AreYouSureYouWantToDelete')"
                    @confirm="handleDel(scope.$index, 'collectFeesList')"
                  >
                    <!--删除-->
                    <template #reference>
                      <el-button type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </template>

      <!-- 运输（干/支线） -->
      <TransportationQuotation
        v-show="isTransportation"
        ref="transportationQuotation"
        :model-list="modelList"
        :stitching-line="stitchingLine"
        :fee-type-list="expenseTypeList"
        :quotation-mode="formData.quotationMode"
        :partition-affiliate-id="formData.partitionAffiliateId"
      />

      <!-- 安俊小屋 -->
      <template v-if="formData.businessType === 1">
        <el-form
          ref="tableForm1"
          :model="formData"
          label-width="0"
          label-position="top"
          class="error-form"
          size="mini"
        >
          <el-table :data="formData.collectFeesList" border>
            <!--费用类型-->
            <el-table-column :label="$t('basicData.ExpenseType')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.ExpenseType') }}</span>
                </div>
              </template>
              <template v-slot="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.feeTypeCode'"
                  :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                >
                  <el-select
                    v-model="scope.row.feeTypeCode"
                    :placeholder="$t('basicData.PleaseSelect')"
                    style="width: 100%;"
                    @change="chargeTypeChange(scope)"
                  >
                    <el-option
                      v-for="item in expenseTypeList"
                      :key="item.id"
                      :label="item.displayName + '(' + item.code + ')'"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <!--货量开始（票）(不包含)-->
            <el-table-column :label="$t('basicData.QuantityStartTicketNotIncluded')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.QuantityStartTicketNotIncluded') }}</span>
                </div>
              </template>
              <template v-slot="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.startOfGoodsQuantity'"
                  :rules="{
                    required: true,
                    suffix: '',
                    negative: '',
                    negative1: 1,
                    package: scope.row.endOfGoodsQuantity,
                    validator: Integer0,
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-input v-model="scope.row.startOfGoodsQuantity" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--货量结束（票）(包含)-->
            <el-table-column :label="$t('basicData.EndOfVolumeTicketIncluded')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.EndOfVolumeTicketIncluded') }}</span>
                </div>
              </template>
              <template v-slot="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.endOfGoodsQuantity'"
                  :rules="{
                    required: true,
                    suffix: '',
                    negative: '',
                    negative1: 2,
                    package: scope.row.startOfGoodsQuantity,
                    validator: Integer0,
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-input v-model="scope.row.endOfGoodsQuantity" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--揽收价格-->
            <el-table-column :label="$t('basicData.PickUpPrice')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.PickUpPrice') }}</span>
                </div>
              </template>
              <template v-slot="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.price'"
                  :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.price" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--揽收费补贴-->
            <el-table-column :label="$t('basicData.logisticsSubsidy')" min-width="180">
              <template v-slot="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.subsidy'"
                  :rules="{ required: false, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.subsidy" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--操作-->
            <el-table-column :label="$t('basicData.operate')" width="120" fixed="right">
              <template v-slot="scope">
                <!--确定删除吗？-->
                <el-popconfirm
                  :title="$t('basicData.AreYouSureYouWantToDelete')"
                  @confirm="handleDel(scope.$index, 'collectFeesList')"
                >
                  <!--删除-->
                  <template #reference>
                    <el-button type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </template>

      <!-- 邮局派送-->
      <PostalDeliveryCmp
        v-show="isPostalDelivery"
        ref="PostalDeliveryCmpRef"
        :subregion-list="subregionList"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
        :fee-type-list="expenseTypeList"
      />

      <!-- 其他规则 【AJD、DSP、干支线】-->
      <OtherCmp
        v-if="[3,4,5].includes(formData.businessType)"
        ref="otherRef"
        :subregion-list="subregionList"
        :stitching-line="stitchingLine"
        :special-fee-list="specialFeeList"
        :business-type="formData.businessType"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
        :ids="editData.id"
        :data-list="otherRuleDataList"
      />
    </div>
    <!--操作按钮-->
    <div class="addFooter">
      <!--取消-->
      <el-button size="small" @click="handleUpdatePage(false)">{{ $t('basicData.Cancel') }}</el-button>
      <!--保存-->
      <el-button
        v-permit:remove="'btn:payable:quoteManagement:addEdit'" size="small" type="primary"
        @click="submitForm"
      >{{ $t('basicData.Save') }}</el-button>
    </div>
    <!--保存提示-->
    <el-dialog
      :title="$t('basicData.tips')"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="400"
    >
      <div v-for="(item, ind) in errData" :key="ind" style="color: red;margin-bottom: 8px;">{{ item }}</div>
      <span slot="footer" class="dialog-footer">
        <!--确 定-->
        <el-button type="primary" @click="dialogVisible = false">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiGetAffiliateById, apiGetPayableOfferPriceById } from '@/api/finance/partition';
import {
  apiListByPayableOfferPriceId,
  apiPayableOfferPriceDetailInsert,
  apiPayableOfferPriceDetailUpdate,
  apilistByOfferPriceId
} from '@/api/finance/basicData';
import { cloneDeep } from 'lodash-es';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
import { Transport_VEHICLE_MODEL, TRANSPORTATION_TYPE } from '@/views/finance/utils.js';
import { PAYABLE_TYPE } from '@/views/finance/enums';
import { CARGO_TYPE, COLLECT_TYPE } from '@/views/finance/enums';

export default {
  components: {
    QueryPartVCmp: () => import('@/views/finance/cmp/Query/QueryPartV2Cmp.vue'),
    ImportDownload: () => import('./ImportDownload'),
    AJDAddCmp: () => import('./AJDCmp/AJDAddCmp.vue'),
    CollectionForwardingCentreHomeDeliveryCmp: () => import('./CollectionForwardingCentreHomeDeliveryCmp/index.vue'),
    CollectionAndDoorToDoorCollectionAndThirdPartyCmp: () => import('./CollectionAndDoorToDoorCollectionAndThirdPartyCmp/index.vue'),
    PostalDeliveryCmp: () => import('./PostalDelivery/index.vue'),
    TransportationQuotation: () => import('./Transportation/Detail.vue'),
    OtherCmp: () => import('./OtherCmp/index.vue')
  },
  mixins: [toolRequestClass],
  props: {
    // 类型标识 1新增 2编辑 4复制
    operationType: {
      type: Number,
      default: 1
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    // 正负保留小数点
    const priceType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.package !== null && rule.package !== '' && rule.package !== undefined) {
              if (rule.negative1 === 2) {
                if (parseFloat(value) <= parseFloat(rule.package)) {
                  return callback(new Error(this.$t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
                } else if (parseFloat(value) <= 0) {
                  return callback(new Error(this.$t('basicData.MustBeGreaterThan0'))); // 必须大于0
                }
              } else {
                if (parseFloat(value) >= parseFloat(rule.package)) {
                  return callback(new Error(this.$t('basicData.MustLessThanEndValue'))); // 必须小于结束值
                } else {
                  return callback();
                }
              }
            }
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.negative1 === 2) {
              if (parseFloat(value) <= parseFloat(rule.package)) {
                return callback(new Error(this.$t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
              } else if (parseFloat(value) <= 0) {
                return callback(new Error(this.$t('basicData.MustBeGreaterThan0'))); // 必须大于0
              }
            } else {
              if (parseFloat(value) >= parseFloat(rule.package)) {
                return callback(new Error(this.$t('basicData.MustLessThanEndValue'))); // 必须小于结束值
              } else {
                return callback();
              }
            }
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };
    // 大于0的正整数
    const Integer0 = (rule, value, callback) => {
      let reg;
      if (rule.negative === 1) {
        reg = /(^[1-9]\d*$)/;
      } else {
        reg = /(^[0-9]\d*$)/;
      }
      if (rule.required) {
        if (value !== null && value !== '' && value !== undefined) {
          if (reg.test(value) === false) {
            if (rule.negative === 1) {
              return callback(new Error(this.$t('basicData.MustPositiveIntegerGreaterThan0'))); // '必须是大于0的正整数'
            } else {
              return callback(new Error(this.$t('basicData.MustPositiveIntegerGreaterThanOrEqual0'))); // '必须是大于或等于0的正整数'
            }
          } else {
            if (rule.package !== null && rule.package !== '' && rule.package !== undefined) {
              if (rule.negative1 === 2) {
                if (parseFloat(value) <= parseFloat(rule.package)) {
                  return callback(new Error(this.$t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
                } else {
                  return callback();
                }
              } else {
                if (parseFloat(value) >= parseFloat(rule.package)) {
                  return callback(new Error(this.$t('basicData.MustLessThanEndValue'))); // 必须小于结束值
                } else {
                  return callback();
                }
              }
            }
            return callback();
          }
        } else {
          return callback(new Error(this.$t('basicData.CannotBeEmpty'))); // '不能为空'
        }
      } else {
        if (value !== null && value !== '' && value !== undefined) {
          if (reg.test(value) === false) {
            if (rule.negative === 1) {
              return callback(new Error(this.$t('basicData.MustPositiveIntegerGreaterThan0'))); // '必须是大于0的正整数'
            } else {
              return callback(new Error(this.$t('basicData.MustPositiveIntegerGreaterThanOrEqual0'))); // '必须是大于或等于0的正整数'
            }
          } else {
            return callback();
          }
        } else {
          return callback();
        }
      }
    };
    // 有效期校验
    const checkBeginTime = (rule, value, callback) => {
      if (this.operationType === 2 && this.editData && this.editData.offerPriceStatus === 1) {
        callback();
      }
      if (!value) {
        return callback(new Error(this.$t('basicData.CannotBeEmpty'))); // '不能为空'
      }
      // const valTime = date2TimeStamp(value);
      // const nowTime = Date.now();
      // if (valTime <= nowTime) {
      //   return callback(new Error(this.$t('basicData.CannotBeLessThanTheCurrentDate'))); // 日期不能小于当前日期
      // }
      callback();
    };
    return {
      PAYABLE_TYPE,
      Transport_VEHICLE_MODEL,
      TRANSPORTATION_TYPE,
      CARGO_TYPE,
      COLLECT_TYPE,
      rules: {
        name: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },
          // '长度在 2 到 50 个字符'
          { min: 2, max: 50, message: this.$t('basicData.TheLengthBetween2And50Characters'), trigger: ['blur', 'change'] }
        ],
        startOfValidityPeriod: [
          { required: !(this.operationType === 2 && this.editData && this.editData.offerPriceStatus === 1), validator: checkBeginTime, trigger: ['blur', 'change'] }
        ],
        businessType: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        partitionId: [
          { required: false, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        payableEntityId: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        providerChannelId: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ],
        transportType: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
        ]
      },
      errData: [],
      dialogVisible: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      subregionList: [], // 分区明细数据
      // 基础数据
      formData: {
        name: '', // 报价名称
        startOfValidityPeriod: '', // 开始时间
        businessType: '', // 业务类型
        collectType: '', // 揽收类型
        cargoType: '', // 货物类型
        // orderPackageType: '', // 包裹类型
        partitionId: '', // 分区id,
        partitionName: '', // 分区名称
        payableEntityId: '', // 应付主体
        payableEntityName: '',
        siteIds: [], // 网点id
        siteName: '', // 网点名称,
        settlementNode: 2, // 结算节点
        providerChannelId: '', // 服务商渠道id
        useVolumeBilling: '', // 是否按体积计费
        calculationMethod: '', // 计费方式
        calculateBase: '', // 计费基数
        partitionAffiliateId: '', // 分区关联明细/车线关联明细id
        collectFeesList: [], // 报价费用列表
        feeTypeList: [] // 其他规则列表
      },
      // 下载导入模板
      tableDataObj: {
        collectFeesList: {},
        feeTypeList: {}
      },
      tableDataArr: {
        collectFeesList: [],
        feeTypeList: []
      },
      Integer0,
      priceType,
      exportKey: new Date().getTime(),
      // selectFeeTypeCode: [],
      feeParams: {
        state: 1, // 启用
        attribute: 2, // 应付
        accountType: 1 // 应付科目
      },
      otherRuleDataList: [] // 其他规则数据
    };
  },

  computed: {
    /**
     * 功能： AJD且货物类型为正常件
     * @returns {boolean}
     */
    isBusinessType3AndOperationMode1() {
      const { businessType, cargoType } = this.formData;
      return businessType === 3 && cargoType === 0;
    },

    /**
     * 功能： 第三方揽收（业务类型） + 上门交件（揽收方式），需要同时满足
     */
    isCollectionForwardingCentreHomeDeliveryCmp() {
      const { businessType, collectType } = this.formData;
      return businessType === 2 && collectType === 1;
    },

    /**
     * 功能： 第三方揽收 （业务类型） + 上门揽收（揽收方式），需要同时满足
     *    条件1：业务类型businessType === 第三方揽收
     *    条件2：揽收方式collectType === 上门揽收
     * @returns {boolean} 符合条件返回true
     */
    isCollectionAndDoorToDoorCollectionAndThirdParty() {
      const { businessType, collectType } = this.formData;
      return businessType === 2 && collectType === 2;
    },

    /**
     * 功能： 邮局派送（业务类型）
     * @returns {boolean}
     */
    isPostalDelivery() {
      const { businessType } = this.formData;
      return businessType === 6;
    },

    /**
     * 功能： 运输干/支线（业务类型）
     * @returns {boolean}
     */
    isTransportation() {
      const { businessType } = this.formData;
      return businessType === 5;
    },

    /**
     * 功能： DSP 业务类型
     * cargoType为0 或者 1且orderPackageType不为空
     * @returns {boolean}
     */
    isDsp() {
      const { businessType, cargoType } = this.formData;
      // 空值检查逻辑为辅助函数
      // const isNotEmpty = (value) => value !== '' && value !== null && value !== undefined;

      // 业务类型为AJD且货物类型为大件，则返回true
      if (businessType === 3 && cargoType === 1) {
        return true;
      }

      // 业务类型为DSP
      return businessType === 4;

      // 业务类型为DSP且货物类型为大件件且包裹类型不为空，则返回true,否则返回false
      // return !!(businessType === 4 && cargoType === 1 && isNotEmpty(orderPackageType));
    },

    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 3600 * 1000; // 不能选择生效日期在当前服务时间之前
        }
      };
    },

    // 禁用日期
    isDisableData() {
      const { offerPriceStatus } = this.editData;
      return offerPriceStatus === 1 && this.operationType === 2;
    }
  },

  watch: {
    // 分区变化
    'formData.partitionAffiliateId'(val) {
      if (val) {
        this.tableDataObj.collectFeesList[val] = this.tableDataObj.collectFeesList[val] || [];
        this.tableDataObj.feeTypeList[val] = this.tableDataObj.feeTypeList[val] || [];
        this.formData['collectFeesList'] = this.tableDataObj.collectFeesList[val];
        this.formData['feeTypeList'] = this.tableDataObj.feeTypeList[val];
      } else {
        this.tableDataArr.collectFeesList = this.tableDataArr.collectFeesList || [];
        this.tableDataArr.feeTypeList = this.tableDataArr.feeTypeList || [];
        this.formData['collectFeesList'] = this.tableDataArr.collectFeesList;
        this.formData['feeTypeList'] = this.tableDataArr.feeTypeList;
      }
    },

    // 分区方案变化
    partitionList: {
      handler() {
        this.formData.partitionName = this.partitionList.find(item => item.id === this.formData.partitionId)?.name;
      },
      deep: true
    },

    // 监听业务类型变化，揽收业务-主体非必填
    'formData.businessType'(val) {
      console.log(val, '业务类型');
      // 业务类型为第三方揽收无需校验主体
      this.rules.payableEntityId[0].required = val !== 2;

      // 业务类型为邮局，分区必填
      this.rules.partitionId[0].required = val === 6;

      this.$nextTick(() => {
        this.$refs.queryForm.clearValidate();
      });
    },

    // 干支线-车线数据-以防返回数据验证渲染数据为空
    stitchingLine(val) {
      if (val.length > 0) {
        this.formData.partitionAffiliateId = val[0].id;
      }
    }
  },

  async created() {
    // 获取主体
    this.getProviderList();
    // 运输主体
    this.getTransportationProviderPage();
    // 获取分区方案
    this.getSubregionData(2);
    // 获取车型
    this.getApiOptionForSelect();
    // 获取车线
    this.getApiCarLineDispatchSystemList();
    // 获取服务商
    this.getProviderChannel();
    // 获取费用类型
    // this.getExpenseTypeList({
    //   ...this.feeParams,
    //   businessType: this.formData.businessType // 业务类型
    // });
    const edit = cloneDeep(this.editData);
    this.$nextTick(() => {
      if (edit.id) {
        // 数据详情
        this.getBasicDataQuotation();
      }
    });
  },
  methods: {
    /**
     * 获取报价编辑详情
     */
    async getBasicDataQuotation() {
      const ids = this.editData.id;
      try {
        const res = await apiGetPayableOfferPriceById(ids);
        const { code, data } = res;
        console.log(res, '报价详情-基本信息');
        if (code === 200) {
          // 主体ID payableEntityId
          let payableEntityId = '';
          if (data.payableEntityId != null) {
            if (data.businessType === 5) {
              payableEntityId = String(data.payableEntityId);
            } else {
              const parsed = parseInt(data.payableEntityId, 10);
              if (!isNaN(parsed)) {
                payableEntityId = parsed;
              }
            }
          }
          this.formData = {
            name: data.name, // 报价名称
            startOfValidityPeriod: data.startOfValidityPeriod
              ? data.startOfValidityPeriod.replace('T', ' ')
              : '', // 生效日期
            businessType: data.businessType, // 业务类型 1 安骏 2 第三方 3 AJD 4 DSP 5 运输干支线 6 邮局
            transportType: data.transportType, // 运输方式
            partitionId: data.partitionId, // 分区方案ID
            partitionName: data.partitionName, // 分区方案名称
            cargoType: data.cargoType, // 货物类型
            // orderPackageType: data.orderPackageType, // 包裹类型
            collectType: data.collectType, // 揽收方式 1 上门交件 2 上门揽收
            payableEntityId: payableEntityId, // 主体ID
            payableEntityName: data.payableEntityName, // 主体名称
            providerBody: data.providerBody,
            code: data.code,
            siteIds: data.siteId, // 网点ID
            siteName: data.siteName, // 网点名称
            settlementNode: data.settlementNode, // 结算节点
            providerChannelId: data.providerChannelId, // 服务商渠道ID
            useVolumeBilling: data.useVolumeBilling, // 是否使用体积计费
            calculationMethod: data.calculationMethod, // 计费方式
            calculateBase: data.calculateBase, // 计费基数
            partitionAffiliateId: data.partitionAffiliateId, // 分区明细 ID/车线 ID
            collectFeesList: [], // 价格详情
            feeTypeList: [] // 其他报价
          };
          const businessType = this.formData.businessType;
          if (businessType === 5) {
            if (this.stitchingLine.length > 0) {
              this.formData.partitionAffiliateId = this.stitchingLine[0].id;
            }
          } else {
            await this.getOtherFeeDetail();
          }

          // 根据业务类型查询费用类型
          this.getExpenseTypeList({
            ...this.feeParams,
            businessType: businessType
          });

          // 编辑时，更新主体数据
          this.searchProviderData();

          // 主体获取网点
          if (payableEntityId && businessType !== 5) {
            this.getSiteQuery(payableEntityId);
          }

          // 获取报价价格详情
          this.asyncGetAffiliateById(ids);

          // 获取其他规则详情
          this.asyncApiListByOfferPriceId(ids);

          this.exportKey = new Date().getTime();
        }
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * 通过报价id获取价格详情
     * @param ids 报价id
     */
    asyncGetAffiliateById(ids) {
      try {
        apiListByPayableOfferPriceId(ids, false)
          .then(res => {
            const { code, data } = res;
            if (code !== 200) {
              return;
            }
            console.log('价格详情', data);
            const { businessType } = this.formData;
            if ([2, 5, 6].includes(businessType)) {
              if (this.isCollectionAndDoorToDoorCollectionAndThirdParty) {
                // 上门揽收
                this.$nextTick(() => {
                  this.$refs.collectionAndDoorToDoorCollectionAndThirdPartyRef.setData(data);
                });
              }
              if (this.isCollectionForwardingCentreHomeDeliveryCmp) {
                // 上门交件
                this.$nextTick(() => {
                  this.$refs.collectionForwardingCentreHomeDeliveryRef.setData(data);
                });
              }
              if (this.isTransportation) {
                // 运输干支线
                this.$nextTick(() => {
                  this.$refs.transportationQuotation.setData(data);
                });
              }
              if (this.isPostalDelivery) {
                // 邮局
                this.$nextTick(() => {
                  this.$refs.PostalDeliveryCmpRef.setData(data);
                });
              }
            } else if (this.isBusinessType3AndOperationMode1) {
              // AJD-正常件
              this.$nextTick(() => {
                this.$refs.ajdAddRef.setData(data);
              });
            } else {
              // 处理 安骏/DSP派送/AJD【大件】
              if (data && data.length > 0) {
                console.log('安俊小屋、DSP派送、AJD【大件】', data, this.formData);
                const partitionedData = {};
                const unPartitionedData = [];

                data.forEach((item) => {
                  if (item.partitionAffiliateId) {
                    // 如果存在分区ID，则按分区ID分类存放
                    if (!partitionedData[item.partitionAffiliateId]) {
                      partitionedData[item.partitionAffiliateId] = [];
                    }
                    partitionedData[item.partitionAffiliateId].push(item);
                  } else {
                    // 如果不存在分区ID，则存放到未分类数组中
                    unPartitionedData.push(item);
                  }
                });

                // 更新原对象或数组
                this.tableDataObj.collectFeesList = partitionedData;
                this.tableDataArr.collectFeesList = unPartitionedData;
              }
            }

            const affiliateId = this.formData.partitionAffiliateId;
            this.formData.collectFeesList = affiliateId
              ? this.tableDataObj.collectFeesList[affiliateId] || []
              : this.tableDataArr.collectFeesList || [];

            this.exportKey = new Date().getTime();
          });
      } catch (err) {
        console.log(err);
      }
    },

    // 获取其他规则详情
    asyncApiListByOfferPriceId(ids) {
      apilistByOfferPriceId(ids).then(res => {
        console.log(res, '其他规则1407');
        if (res.code !== 200) { return; }

        if (Array.isArray(res.data)) {
          this.otherRuleDataList = res.data;
          // this.$refs.otherRef.setData(res.data);
        }
      }).catch(err => {
        console.error(err);
      });
    },

    // 清空普通报价详情
    clearOffers(type) {
      const { businessType, partitionAffiliateId } = this.formData;
      const dataList = businessType === 5 ? this.stitchingLine : this.subregionList;

      this.formData['collectFeesList'] = [];
      if (dataList && dataList.length > 0) {
        if (type === 1) {
          // 清空当前分区
          if (partitionAffiliateId != null) {
            this.tableDataObj.collectFeesList[partitionAffiliateId] = [];
          }
        } else {
          // 清空所有分区
          dataList.forEach(item => {
            if (item.id != null) {
              this.tableDataObj.collectFeesList[item.id] = [];
            }
          });
        }
      } else {
        this.tableDataArr.collectFeesList = [];
      }
    },
    // 揽收方式变化
    collectTypeChange() {
      this.formData['collectFeesList'] = [];
      this.formData['feeTypeList'] = [];
      if (this.formData.partitionId) {
        this.tableDataObj = {
          collectFeesList: {},
          feeTypeList: {}
        };
      } else {
        this.tableDataArr = {
          collectFeesList: [],
          feeTypeList: []
        };
      }
      this.exportKey = new Date().getTime();
    },
    // 获取已选费用类型code
    // disabledFeeTyp() {
    //   this.selectFeeTypeCode = [];
    //   this.formData.collectFeesList.map(item => {
    //     this.selectFeeTypeCode.push(item.feeTypeCode);
    //   });
    // },

    // 计费类型变化判断同一费用类型是否存在多种计费类型
    chargeTypeChange(scope) {
      this.formData.collectFeesList.map((item, ind) => {
        if (ind !== scope.$index) {
          if (item.feeTypeCode && (item.feeTypeCode === scope.row.feeTypeCode)) {
            if (item.billingType && (item.billingType !== scope.row.billingType)) {
              this.$message.warning(this.$t('basicData.ThereCantBeDifferentBillingTypesForTheSameChargeType')); // '同一费用类型不能存在相同计费类型'
              this.formData.collectFeesList[scope.$index].billingType = '';
            }
          }
        }
      });
    },
    // 获取分区方案明细详情
    getOfferAffiliateList(id) {
      apiGetAffiliateById(id, false).then(res => {
        if (res.code === 200) {
          this.subregionList = res.data.partitionAffiliateList || [];
          this.formData.partitionAffiliateId = this.subregionList[0].id;
        }
      });
    },
    // 站点变化
    siteIdChange(val) {
      if (val) {
        this.outletsList.map(item => {
          if (val === item.id) {
            this.formData.siteName = item.name;
          }
        });
      } else {
        this.formData.siteName = '';
      }
    },
    /**
     * 应付主体变化同步清除网点数据
     * @param val
     */
    providerInfoChange(val) {
      this.formData.siteIds = [];
      this.formData.siteName = '';
      this.outletsList = [];
      const { businessType } = this.formData;
      const providerDataList = businessType === 5 ? this.transportationProviderList : this.providerData;
      // 更新主体name
      providerDataList.map(item => {
        if (item.id === val) {
          this.formData.payableEntityName = item.providerName;
        }
      });
      // 非干支线业务通过主体查网点
      if (this.formData.businessType !== 5) {
        this.getSiteQuery(val);
      }
    },
    /**
     * 业务类型变化 触发更新分区及费用类型数据、结算节点
     * @params val 业务类型 1 安骏 2 第三方 3 AJD 4 DSP 5 运输 6 邮局
     */
    changeBusinessType(val) {
      this.formData.partitionId = ''; // 清空分区
      this.formData.partitionName = '';
      this.formData['collectFeesList'] = []; // 清空费用明细

      // AJD
      this.formData.settlementNode = val === 3 ? 2 : ''; // 清空结算节点
      // 揽收业务
      if (val !== 2) {
        this.formData.collectType = ''; // 清空揽收方式
      }
      // DSP
      if (val !== 4) {
        this.formData.cargoType = ''; // 清空货物类型
        // this.formData.orderPackageType = ''; // 清空包裹类型
      }
      // 运输
      if (val !== 5) {
        this.formData.transportType = ''; // 运输类型
      }
      // 邮局
      if (val !== 6) {
        this.formData.providerChannelId = '';
        this.formData.useVolumeBilling = 0;
        this.formData.calculationMethod = '';
        this.formData.calculateBase = '';
      }
      // 运输、邮局清空网点
      if (val === 5 || val === 6) {
        this.formData.siteIds = [];
        this.formData.siteName = '';
      }

      const { partitionId, businessType } = this.formData;
      this.formData['feeTypeList'] = [];
      // 获取费用类型
      this.getExpenseTypeList({
        ...this.feeParams,
        businessType: businessType // 业务类型
      });
      if (partitionId) {
        this.tableDataObj = {
          collectFeesList: {},
          feeTypeList: {}
        };
      } else {
        this.tableDataArr = {
          collectFeesList: [],
          feeTypeList: []
        };
      }

      this.exportKey = new Date().getTime();
    },

    /**
     * 切换分区方案重置报价
     */
    async getOtherFeeDetail() {
      try {
        const { partitionId } = this.formData;
        // 分区方案ID是否存在
        if (partitionId) {
          // 分区明细
          await this.getOfferAffiliateList(this.formData.partitionId);
          this.tableDataObj = {
            collectFeesList: {},
            feeTypeList: {}
          };
        } else {
          this.formData.partitionName = '';
          this.tableDataArr = {
            collectFeesList: [],
            feeTypeList: []
          };
        }
        // 初始化价格详情
        if (this.subregionList && this.subregionList.length > 0) {
          this.subregionList.map(item => {
            this.tableDataObj.collectFeesList[item.id] = [];
            this.tableDataObj.feeTypeList[item.id] = [];
          });
        } else {
          this.tableDataArr.collectFeesList = [];
          this.tableDataArr.feeTypeList = [];
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 增加报价
    handleAdd() {
      const obj = {
        partitionAffiliateId: this.formData.partitionAffiliateId, // 分区
        feeTypeCode: '', // 费用类型
        billingType: '', // 计费类型，1:重量，2:票数
        collectType: this.formData.collectType, // 揽收类型 1：上门交件 2：上门揽收
        startOfGoodsQuantity: '', // 货量开始（票）
        endOfGoodsQuantity: '', // 货量结束（票）
        price: '', // 价格
        subsidy: '', // 揽收补贴价格
        startWeight: '', // 开始重量
        endWeight: '', // 结束重量
        overWeightExtraPrice: '', // 0-31KM超重加价
        innerDistancePrice: '', // 0-31KM价格
        outerDistancePrice: '', // 31-101KM价格
        greaterThanDistancePrice: '', // >=100KM价格
        overKilometerExtraPrice: '', // 超出公里加价（每KM）
        greaterThanKilometerExtraPrice: '' //  >=100千米超出重量加价（每KG）
      };
      this.formData['collectFeesList'].push(obj);
      if (this.formData.partitionAffiliateId) {
        this.tableDataObj.collectFeesList[this.formData.partitionAffiliateId] = this.formData['collectFeesList'];
      } else {
        this.tableDataArr.collectFeesList = this.formData['collectFeesList'];
      }
      this.exportKey = new Date().getTime();
    },

    /**
     * 导入价格详情
     * AJD【大件】、DSP、安骏小屋
     */
    importPartition(arr) {
      console.log(arr, '导入价格详情', this.formData.businessType);
      if (this.subregionList && this.subregionList.length > 0) {
        this.subregionList.map(item => {
          this.tableDataObj.collectFeesList[item.id] = this.tableDataObj.collectFeesList[item.id] || [];
        });
      } else {
        this.tableDataArr.collectFeesList = this.tableDataArr.collectFeesList || [];
      }

      setTimeout(() => {
        for (let i = 0; i < arr.length; i++) {
          try {
            if (arr[i].partitionAffiliateId) {
              this.tableDataObj.collectFeesList[arr[i].partitionAffiliateId].push(arr[i]);
            } else {
              this.tableDataArr.collectFeesList.push(arr[i]);
            }
          } catch (err) {
            this.$message.warning(this.$t('basicData.templatePartition'));
            break;
          }
        }
        if (this.formData.partitionAffiliateId) {
          this.formData['collectFeesList'] = this.tableDataObj.collectFeesList[this.formData.partitionAffiliateId] || [];
        } else {
          this.formData['collectFeesList'] = this.tableDataArr.collectFeesList || [];
        }
        this.exportKey = new Date().getTime();
      }, 500);
    },
    // 删除分区
    handleDel(index, type) {
      this.formData[type].splice(index, 1);
      if (this.formData.partitionAffiliateId) {
        this.tableDataObj[type][this.formData.partitionAffiliateId] = this.formData[type];
      } else {
        this.tableDataArr[type] = this.formData[type];
      }
      this.exportKey = new Date().getTime();
    },
    // 取消
    handleUpdatePage(type) {
      this.$emit('saveData', type);
    },

    // 校验列表数据
    async verificationTable() {
      let tableForm1 = false;

      // 其他规则-AJD、DSP、干支线校验
      if ([3, 4, 5].includes(this.formData.businessType)) {
        try {
          if (this.$refs.otherRef && typeof this.$refs.otherRef.submitForm === 'function') {
            const isBool = await this.$refs.otherRef.submitForm();
            if (!isBool) {
              return false;
            }
          } else {
            return false;
          }
        } catch (error) {
          return false;
        }
      }

      // 如果选择了 揽收+上门揽收
      if (this.isCollectionAndDoorToDoorCollectionAndThirdParty) {
        // 直接调用子级的校验方法
        return await this.$refs.collectionAndDoorToDoorCollectionAndThirdPartyRef.submitForm();
      }

      // 如果选择了 派送+AJD
      if (this.isBusinessType3AndOperationMode1) {
        // 直接调用子级的校验方法
        return await this.$refs.ajdAddRef.submitForm();
      }

      // 选择了 揽收（业务类型） + 上门交件（揽收方式）
      if (this.isCollectionForwardingCentreHomeDeliveryCmp) {
        return await this.$refs.collectionForwardingCentreHomeDeliveryRef.submitForm();
      }

      // 邮政派送
      if (this.isPostalDelivery) {
        return await this.$refs.PostalDeliveryCmpRef.submitForm();
      }

      // 运输报价
      if (this.isTransportation) {
        return await this.$refs.transportationQuotation.submitForm();
      }

      this.$refs.tableForm1.validate((tabRules) => {
        tableForm1 = tabRules;
      });

      return tableForm1;
    },
    // 保存
    submitForm() {
      this.errData = [];
      this.$refs.queryForm.validate(async(valid) => {
        if (!valid) {
          return;
        }
        // 校验列表
        {
          const isBool = await this.verificationTable();

          if (!isBool) {
            return false;
          }
        }

        // 网点字段处理
        let siteIds;
        if (this.editData.id) {
          const { siteIds: site } = this.formData;

          // 类型是 数组
          if (Array.isArray(site)) {
            siteIds = site.join(',');
          } else {
            siteIds = site;
          }
        } else {
          // 新增
          siteIds = this.formData.siteIds.join(',');
        }

        const param = {
          name: this.formData.name, // 报价方案名称
          startOfValidityPeriod: this.formData.startOfValidityPeriod, // 有效期开始时间
          businessType: this.formData.businessType, // 业务类型
          cargoType: this.formData.cargoType, // 货物类型
          // orderPackageType: this.formData.orderPackageType, // 包裹类型
          partitionId: this.formData.partitionId, // 关联的分区ID
          partitionName: this.formData.partitionName,
          payableEntityId: this.formData.payableEntityId, // 应付主体(应付账户id)
          payableEntityName: this.formData.payableEntityName,
          siteIds, // 网点id
          siteName: this.formData.siteName,
          collectType: this.formData.collectType, // 揽收方式 1：上门交件 2：上门揽收
          settlementNode: this.formData.settlementNode, // 结算节点
          transportType: this.formData.transportType, // 运输方式
          providerChannelId: this.formData.providerChannelId, // 服务商渠道id
          useVolumeBilling: this.formData.useVolumeBilling, // 是否按体积计费
          calculationMethod: this.formData.calculationMethod, // 计费方式
          calculateBase: this.formData.calculateBase, // 计费基数
          detailList: [],
          otherRulesList: []
        };

        // 选择了 第三方揽收（业务类型） + 上门交件（揽收方式）
        if (this.isCollectionForwardingCentreHomeDeliveryCmp) {
          const arr = this.$refs.collectionForwardingCentreHomeDeliveryRef.getData();
          this.asyncAddAndUpdate(param, arr);
          return;
        }

        // 选择了 第三方揽收（业务类型） + 上门揽收（揽收方式）
        if (this.isCollectionAndDoorToDoorCollectionAndThirdParty) {
          const arr = this.$refs.collectionAndDoorToDoorCollectionAndThirdPartyRef.getData();
          this.asyncAddAndUpdate(param, arr);
          return;
        }

        // 选择了邮政派送
        if (this.isPostalDelivery) {
          const arr = this.$refs.PostalDeliveryCmpRef.getData();
          this.asyncAddAndUpdate(param, arr);
          return;
        }

        // 选择了 派送+AJD
        if (this.isBusinessType3AndOperationMode1) {
          const arr = this.$refs.ajdAddRef.getData();
          this.asyncAddAndUpdate(param, arr);
          return;
        }

        // 选择了 运输干支线
        if (this.isTransportation) {
          const arr = this.$refs.transportationQuotation.getData();
          this.asyncAddAndUpdate(param, arr);
          console.log(arr, param);
          return;
        }

        // 安骏、DSP、AJD【正常件】
        if (this.formData.partitionAffiliateId) {
          for (const k in this.tableDataObj.collectFeesList) {
            if (this.tableDataObj.collectFeesList[k] && this.tableDataObj.collectFeesList[k].length > 0) {
              this.tableDataObj.collectFeesList[k].map((item) => {
                param.detailList.push(item);
              });
            }
          }
          for (const k in this.tableDataObj.feeTypeList) {
            if (this.tableDataObj.feeTypeList[k] && this.tableDataObj.feeTypeList[k].length > 0) {
              this.tableDataObj.feeTypeList[k].map((item) => {
                param.otherRulesList.push(item);
              });
            }
          }
        } else {
          this.tableDataArr.collectFeesList.map((item) => {
            param.detailList.push(item);
          });

          this.tableDataArr.feeTypeList.map((item) => {
            param.otherRulesList.push(item);
          });
        }
        if (this.errData.length > 0) {
          this.dialogVisible = true;
          return;
        }
        // 费用类型取值code
        if (param?.detailList?.length > 0) {
          param.detailList.forEach(item => {
            // 判断feeTypeCode字段是否存在，并且有值
            if (item.feeTypeCode) {
              // 取字符串->后面的字符
              if (item.feeTypeCode && item.feeTypeCode.includes('->')) {
                item.feeTypeCode = item.feeTypeCode.split('->')[1];
              }
            }
          });
        }

        // 其他规则
        // param.otherRulesList = this.$refs.otherRef.getData();

        // 提交数据 安骏、DSP、AJD【大件】
        this.postData(param);
      });
    },

    // 第三方、AJD【正常件】、干支线、邮局派送保存
    async asyncAddAndUpdate(query, arr) {
      const params = cloneDeep(query);
      // params.otherRulesList = this.$refs.otherRef.getData();
      console.log(params, arr, '保存报价');
      const param = {
        ...params,
        detailList: arr
      };
      this.postData(param);
    },
    /**
     * 数据保存
     * @param data 数据
     */
    postData(data) {
      // 其他规则
      if ([3, 4, 5].includes(data.businessType)) {
        // 获取其他规则
        data.otherRulesList = this.$refs.otherRef.getData();
      }
      // 新增1 或 复制4 || 2更新
      const API = [1, 4].includes(this.operationType) ? apiPayableOfferPriceDetailInsert : apiPayableOfferPriceDetailUpdate;
      const submitParam = { ...data, id: [1, 4].includes(this.operationType) ? null : this.editData.id };
      console.log(submitParam, API, '====API');
      API(submitParam).then(res => {
        console.log('保存成功', res);
        this.$message.success(this.$t('basicData.TheOperationSucceeded'));
        this.$emit('saveData', true);
      }).catch(error => {
        console.log('error', error);
      });
    },
    // 业务主体
    searchProviderData() {
      const { businessType } = this.formData; // 业务类型
      const isTransportEntity = businessType === 5;
      const list = isTransportEntity ? this.transportationProviderList : this.providerData;
      this.updateProviderData(list);
    },
    // 更新主体
    updateProviderData(arr = []) {
      const { businessType, payableEntityId, payableEntityName, providerBody, code } = this.formData || {};
      const safeArr = [...arr];
      // 编辑时更新,不存在时添加
      if (this.operationType !== 1 && payableEntityId != null) {
        const exists = safeArr.some(item => item.id === payableEntityId);
        if (!exists) {
          safeArr.unshift({
            id: payableEntityId,
            providerName: payableEntityName,
            providerBody,
            code
          });
        }
      }
      if (businessType !== 5) {
        this.providerData = safeArr;
      }
      console.log(this.providerData, this.transportationProviderList, '更新主体', payableEntityName);
    }
  }
};
</script>

<style scoped>
.addFormBox {
  padding: 20px;
  height: calc(100vh - 100px);
  overflow-y: auto;
}

.addFooter {
  border-top: 1px solid #ccc;
  text-align: right;
  padding: 10px;
}

.title {
  padding: 15px 10px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}

.volume {
  display: flex;
}
</style>
